<template>
  <section
    v-if="banner"
    class="banner container p-0 mb-3"
    :class="{ mobile: mobile_view, desktop: !mobile_view, invisible: loading}"
  >
    <div>
      <img
        class="banner_img w-100"
        :src="getAssetLink(banner)"
      >
    </div>
  </section>
</template>
<script>
export default {
  name: "Banner",
  props: ["banner"],
  data() {
    return {
      mobile_view: false,
      loading: true
    };
  },
  mounted: function() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  methods: {
    onResize() {
      if (document.documentElement.clientWidth > 640) {
        this.mobile_view = false;
        this.default_image = this.$config.lazyload.banner;
      } else {
        this.mobile_view = true;
        this.default_image = this.$config.lazyload.banner_mobile;
      }
    },
    getLazyLoadObj(src) {
      return {
        src: this.getAssetLink(src),
        error: this.default_image,
        loading: this.default_image
      };
    }
  }
};
</script>
